import { render, staticRenderFns } from "./ClinicMateriel.vue?vue&type=template&id=67d9d769"
import script from "./ClinicMateriel.vue?vue&type=script&lang=js"
export * from "./ClinicMateriel.vue?vue&type=script&lang=js"
import style0 from "./ClinicMateriel.vue?vue&type=style&index=0&id=67d9d769&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d9d769')) {
      api.createRecord('67d9d769', component.options)
    } else {
      api.reload('67d9d769', component.options)
    }
    module.hot.accept("./ClinicMateriel.vue?vue&type=template&id=67d9d769", function () {
      api.rerender('67d9d769', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicMateriel.vue"
export default component.exports